/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_content_chip11 = /** @type {(inputs: {}) => string} */ () => {
	return `Content`
};

const fr_content_chip11 = /** @type {(inputs: {}) => string} */ () => {
	return `Contenu`
};

const de_content_chip11 = /** @type {(inputs: {}) => string} */ () => {
	return `Inhalt`
};

const es_content_chip11 = /** @type {(inputs: {}) => string} */ () => {
	return `Contenido`
};

const it_content_chip11 = /** @type {(inputs: {}) => string} */ () => {
	return `Contenuto`
};

const ar_content_chip11 = /** @type {(inputs: {}) => string} */ () => {
	return `محتوى`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const content_chip11 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.content_chip11(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("content_chip11", locale)
	if (locale === "en") return en_content_chip11(inputs)
	if (locale === "fr") return fr_content_chip11(inputs)
	if (locale === "de") return de_content_chip11(inputs)
	if (locale === "es") return es_content_chip11(inputs)
	if (locale === "it") return it_content_chip11(inputs)
	return ar_content_chip11(inputs)
};
export { content_chip11 as "CONTENT_CHIP" }